module.exports = __webpack_public_path__ + "static/media/foltest.10d6b448.png";